

































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'
import BillApi from '@/api/bill2'

@Component({})
export default class KeyVisits extends Mixins(addTaskMixin) {
	public taskType: any = '21'
	public activated() {
		this.getProvList()
		if (this.$route.query.addSettle) {
			const newSettle = this.$ss.get('newSettle')
			this.addForm.setFieldsValue({
				patientName: newSettle.patientName,
				idCard: newSettle.idCard,
				telPhone: newSettle.telPhone,
			})
			this.relateRecordId = newSettle.relateRecordId
			this.parentOrderId = newSettle.parentOrderId
		}
	}

	public created() {
		this.getProvList()
	}
}
